import { Collection } from "./Collection";
import {BaseModel} from "./Base";

export class DayWorkhourModel extends BaseModel {
    day: string = "";
    daynumber: number;
    wholeDay: boolean = true;
    isWorking:boolean = false;
    customRules: Array<any> = [];
    
    constructor(data = null) {
        super();
        
        if (typeof data === 'string' || data instanceof String) {
            this.day = data+"";
        }
        if (typeof data === 'object' || data instanceof Object) {
            for(let i in data) {
                this[i] = data[i];
            }
        }
    }
    
    isAvailable() {
        return this.isWorking;
    }
}

export class DayWorkhours extends Collection {

    constructor(data = null) {
        super(data);
    }
    
    update(data: any): void {
        this.items.map((item) => {
            
            if(item == data) {
                
                item = data;
            }
        })
    }
}